import { BatchAddMemberFormRow } from '../types/batch-add-member-form-row';
import { MembersFileRecord } from '../../batch-add-members-file-preview-modal/interfaces/members-file-record';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { sinValidator } from '../../../../../validators/valid-sin.validator';
import { dateFormatValidator } from '../../../../../validators/date-format.validator';
import * as moment from 'moment';
import { dateNotInFutureValidator } from '../../../../../validators/date-not-in-future.validator';

export class BatchAddMembersFormFactory {
  static initializeMemberFormRow(member?: MembersFileRecord): BatchAddMemberFormRow {
    const acceptedFormats = [
      'MMMM D, YYYY', // January 8, 1990
      'MMM D, YYYY', // Jan 8, 1990
      'DD-MM-YYYY', // 08-01-1990
      'DDMMYYYY' // 08011990
    ];

    const formattedDateOfBirth = member?.['DATE OF BIRTH']
      ? moment(member['DATE OF BIRTH'], acceptedFormats, true).format('DD/MM/YYYY').toString()
      : '';

    const formattedEmploymentStartDate = member?.['EMPLOYMENT START']
      ? moment(member['EMPLOYMENT START'], acceptedFormats, true).format('DD/MM/YYYY').toString()
      : '';

    return new FormGroup({
      lastName: new FormControl<string>(member?.['LAST NAME'] ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      firstName: new FormControl<string>(member?.['FIRST NAME'] ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      dateOfBirth: new FormControl<string>(formattedDateOfBirth, {
        nonNullable: true,
        validators: [Validators.required, dateFormatValidator, dateNotInFutureValidator]
      }),
      socialInsuranceNumber: new FormControl<string>(member?.SIN?.toString() ?? '', {
        nonNullable: true,
        validators: [Validators.required, sinValidator]
      }),
      email: new FormControl<string>(member?.EMAIL ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.email]
      }),
      employmentStartDate: new FormControl<string>(formattedEmploymentStartDate, {
        nonNullable: true,
        validators: [Validators.required, dateFormatValidator]
      }),
      onLeave: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.required] }),
      leaveType: new FormControl<number | null>({ value: null, disabled: true }),
      leaveStartDate: new FormControl<string | null>({ value: null, disabled: true }),
      leaveExpectedReturnDate: new FormControl<string | null>({ value: null, disabled: true })
    });
  }
}
